const TFA_GROUPS = Object.freeze({
    ROTH_IRA: 'ROTH_IRA',
    TRADITIONAL_IRA: 'TRADITIONAL_IRA',
    SINGLE_HSA: 'SINGLE_HSA',
    FAMILY_HSA: 'FAMILY_HSA'
})

export default TFA_GROUPS